import React, { useEffect, useState } from 'react';
import Carousel from './carousel';

const isUsableImageUrl = (value) => {
    if (typeof value !== 'string' || !value.trim()) {
        return false;
    }

    try {
        const url = new URL(value);
        return url.protocol === 'https:';
    } catch (error) {
        return false;
    }
};

const BucketCarousel = ({ spacingClassName }) => {
    const [images, setImages] = useState([]);

    useEffect(() => {
        const controller = new AbortController();
        let isMounted = true;

        const loadImages = async () => {
            try {
                const response = await fetch('/api/carousel-images', {
                    signal: controller.signal
                });

                if (!response.ok) {
                    return;
                }

                const payload = await response.json();
                if (!isMounted || !Array.isArray(payload?.images)) {
                    return;
                }

                const usableImages = [...new Set(payload.images.filter(isUsableImageUrl))];
                if (usableImages.length) {
                    setImages(usableImages);
                }
            } catch (error) {
                return;
            }
        };

        loadImages();

        return () => {
            isMounted = false;
            controller.abort();
        };
    }, []);

    if (!images.length) {
        return null;
    }

    return <Carousel images={images} spacingClassName={spacingClassName} />;
};

export default BucketCarousel;
